export default {
    en: {
        week: 'Last week',
        halfMonth: 'Last 15 days',
        alarmSearch: 'Task Name/Operator',
        allFilter: 'All Filters',
        basicFilter: 'Basic Filters',
        critical: 'Critical',
        major: 'Major',
        minor: 'Minor',
        continue: 'In Progress',
        solved: 'Solved',
        ignored: 'Ignored',
        type: 'Type',
        level: 'Level',
        status: 'Status',
        device: 'Device',
        all: 'All',
        incidentCrowd: 'Crowd Counting',
        incidentQueueTiming: 'Queue Time',
        incidentQueueCounting: 'Queue Length',
        incidentOffDuty: 'Unauthorized Leave',
        crowdRetention: 'Crowd Retention',
        crowdCounting: 'Crowd Counting',
        crowdCounterflow: 'Crowd Counterflow',
        crowdIntrusion: 'Crowd Intrusion',
        closeSocialDistance: 'Close Social Distance',
        crowdGather: 'Crowd Gather',
        crowdScatter: 'Crowd Dispersion',
        faceComparison: 'Face Comparison',
        unmatchedFaceComparison: 'Unmatched Face Comparison',
        faceBodyRecognition: 'Face & Body Recognition',
        codeOfConduct: 'Personnel Behavior',
        wasteDetection: 'Waste Detection',
        pavementDefects: 'Pavement Defects',
        face: 'Face',
        queueManagement: 'Queue Management',
        crowdGatherAndDispersion: 'Crowd Gather and Dispersion',
        crowdAndIndividual: 'Crowd And Individual',
        potholeConfidence: 'Potholes',
        alligatorConfidence: 'Alligator Crack',
        ravelingConfidence: 'Loose',
        linearConfidence: 'Linear Crack',
        subsidenceConfidence: 'Subsidence',
        exposeConfidence: 'Waste Exposed',
        overFillConfidence: 'Waste Flowing',
        hatlessConfidence: 'No Chef Hat',
        notWearingUniformConfidence: 'No Uniform',
        shirtlessConfidence: 'Shirtless',
        notWearingMaskConfidence: 'No Mask',
        smokingConfidence: 'Smoke',
        playPhoneConfidence: 'Play Phone',
        phoneCallConfidence: 'Phone Call',
        lastHour: 'Last Hour',
        today: 'Today',
        ignoreAll: 'Ignore All',
        allSolve: 'All Solved',
        showLess: 'Show Less',
        addNote: 'Add Note',
        solve: 'Solve',
        ignore: 'Ignore',
        delete: 'Delete',
        beforeView: 'Before viewing the full SK, please enter your login password:',
        enterPwd: 'Please enter your login password',
        cancel: 'Cancel',
        submit: 'Submit',
        confirmDelete: 'Are you sure to delete this alert?',
        progress: '{progressNum} in progress，{totalNum} alerts in total',
        results: '{results} Results',
        incidentType: '{type} ({num})',
        lastedNumber: 'Number of people: {num}',
        lastedTime: 'Lasted for {num}',
        estimatedQueueTime: 'Estimated queue time: {num}',
        alarmDetails: 'alarmDetails',
        capture: 'Capture subject information',
        timeOfDuration: 'Time Of Duration',
        socialDistance: 'Social Distance',
        snapTime: 'Snap Time',
        validTime: 'Valid Time',
        portraitLibary: 'Portrait Libary',
        matchingRate: 'Matching Rate',
        visitors: 'Visitors',
        area: 'Area',
        task: 'Task',
        note: 'Note',
        equipment: 'Capture Equipment',
        region: 'Region',
        processing: 'Alarm status processing',
        verify: 'verify',
        alarm: 'False Alarm',
        remarks: 'Warning Remarks',
        image: 'image({msg})',
        solvedBtn: 'Solve',
        confirmIgnore: 'Are you sure to mark this alert as ignored? ',
        confirmSolved: 'Are you sure to mark this alert as solved? ',
        textarea: 'Typing',
        statusContinue: 'In Progress',
        statusSolved: 'Solved',
        statusIgnored: 'Ignored',
        operator: 'Operator',
        tips: 'Tips',
        permanent: 'Always',
        tiggerMode: 'Tigger Mode',
        alertMode: 'Alert Mode',
        textDistance: 'Distance',
        gatherTime: 'Gather Time',
        portraitLibaryPhoto: 'Portrait Libary Photo',
        meters: 'Meters',
        gather: 'Gather',
        spread: 'Spread',
        concentric: 'Concentric',
        sameDirection: 'Same Direction',
        seconds: 'seconds',
        comma: ',',
        confidence: 'Confidence',
        roadDefectDetectThreshold: 'Road Detection Confidence',
        trashDetectThreshold: 'Waste Detection Confidence',
        kitchenBehaviorDetectThreshold: 'Kitchenware Detection Confidence',
        layer: 'Layer',
        currentTime: '{num} ago',
        road: 'Road',
        waste: 'Waste',
        kitchen: 'Kitchenware',
        touchFaceConfidence: 'Touch Face',
        eatFoodConfidence: 'Eat Food',
        animalsInsects: 'Animals & Pest',
        mouseDetectConfidence: 'Mouse',
        catDetectConfidence: 'Cat',
        dogDetectConfidence: 'Dog',
        tableDetection: 'Table Detection',
        foodResidueConfidence: 'Food Residue',
        lidUncoverDetectConfidence: 'Open The Lid',
        fireDetection: 'Fire Detection',
        abnormalBehavior: 'Abnormal Behavior',
        fallDownConfidence: 'Falling Down',
        fightingConfidence: 'Fighting',
        traffic: 'Traffic',
        trafficReverseConfidence: 'Counterflow Driving',
        counterflowDriving: 'Counterflow Driving',
        trafficIllegalStopConfidence: 'Illegal Parking',
        trashBinUncoverConfidence: 'Waste Uncovered',
        abnormalBehaviorDetectThreshold: 'Abnormal Behavior Confidence',
        foldAllConfidence: 'Fold All Confidence',
        showAllConfidence: 'Show All Confidence',
        fireDetectionConfidence: 'Fire Detection Confidence',
        fire: 'Fire',
        pestDetectThreshold: 'Animals & Pest Confidence',
        tableDetectThreshold: 'Table Detection Confidence',
        kitchenWareThreshold: 'Kitchenware Confidence',
        trafficReverseThreshold: 'Traffic Detection Confidence',
        trafficIllegalStopThreshold: 'Traffic Detection Confidence',
        confirm: 'Confirm',
        mainImage: 'Main Image',
        libaryImage: 'Libary Image',
        unidentifiedObjectRetention: 'Unidentified Object Retention Detection',
        unidentified: 'Object',
        nonMotorVehicle: 'Non-motor Vehicle',
    },
    zh: {
        week: '近一周',
        halfMonth: '近15天',
        alarmSearch: '任务名称/创建人',
        allFilter: '所有筛选项',
        basicFilter: '基础筛选项',
        critical: '重度',
        major: '中度',
        minor: '轻度',
        continue: '进行中',
        solved: '已解决',
        ignored: '已忽略',
        type: '告警类型',
        level: '告警等级',
        status: '告警状态',
        device: '视频源',
        all: '全部',
        incidentCrowd: '人群统计',
        incidentQueueTiming: '排队时长',
        incidentQueueCounting: '排队人数',
        incidentOffDuty: '离岗检测',
        crowdRetention: '人群滞留',
        crowdCounting: '人群计数',
        crowdCounterflow: '人群逆流',
        crowdIntrusion: '人群入侵',
        closeSocialDistance: '社交距离过近',
        crowdGather: '人群聚集',
        crowdScatter: '人群分散',
        faceComparison: '人脸比对',
        unmatchedFaceComparison: '人脸未比中',
        faceBodyRecognition: '人脸&人体识别',
        codeOfConduct: '厨房行为检测',
        wasteDetection: '垃圾检测',
        pavementDefects: '路面缺陷',
        face: '人脸任务',
        queueManagement: '排队管理',
        crowdGatherAndDispersion: '人群聚集分散',
        crowdAndIndividual: '人群任务',
        potholeConfidence: '坑槽',
        alligatorConfidence: '龟裂',
        ravelingConfidence: '松散',
        linearConfidence: '裂缝',
        subsidenceConfidence: '沉降',
        exposeConfidence: '垃圾暴露',
        overFillConfidence: '垃圾满溢',
        hatlessConfidence: '未戴帽子',
        notWearingUniformConfidence: '未穿厨师服',
        shirtlessConfidence: '未穿上衣',
        notWearingMaskConfidence: '未戴口罩',
        smokingConfidence: '吸烟',
        playPhoneConfidence: '玩手机',
        phoneCallConfidence: '打电话',
        lastHour: '最近一小时',
        today: '今日',
        ignoreAll: '全部忽略',
        allSolve: '解决全部',
        showLess: '更多',
        addNote: '添加笔记',
        solve: '解决',
        ignore: '忽略',
        delete: '删除',
        beforeView: '导出列表之前，请输入你的登陆密码：',
        enterPwd: '请输入你的登陆密码',
        cancel: '取消',
        submit: '确认',
        confirmDelete: '确认删除该告警？',
        progress: '告警中 {progressNum} 条，总共 {totalNum} 条',
        results: '{results} 条',
        incidentType: '{type} ({num})',
        lastedNumber: '人数：{num} 人',
        lastedTime: '时长：{num}',
        estimatedQueueTime: '预计排队时间： {num}',
        alarmDetails: '告警详情',
        capture: '抓拍主体信息',
        equipment: '抓拍设备',
        region: '所属区域',
        processing: '告警状态处理',
        verify: '核实',
        alarm: '误报',
        remarks: '告警备注1',
        image: '图片({msg})',
        timeOfDuration: '持续时间',
        socialDistance: '社交距离',
        snapTime: '抓拍时间',
        validTime: '生效时间',
        portraitLibary: '人像库',
        matchingRate: '匹配度阈值',
        visitors: '实际滞留人数',
        area: '所属区域',
        task: '任务名称',
        note: '备注',
        solvedBtn: '解决',
        confirmIgnore: '确认忽略该警告？',
        confirmSolved: '确认解决该警告？',
        textarea: 'Typing',
        statusContinue: '进行中',
        statusSolved: '已解决',
        statusIgnored: '已忽略',
        operator: '操作员',
        tips: '提示',
        permanent: '永久生效',
        tiggerMode: '告警模式',
        alertMode: '告警触发方式',
        textDistance: '聚集人数',
        gatherTime: '聚集时间',
        portraitLibaryPhoto: '人像',
        meters: '米',
        gather: '聚集',
        spread: '分散',
        concentric: '同心',
        sameDirection: '同向',
        seconds: '秒',
        comma: '，',
        confidence: '置信度',
        roadDefectDetectThreshold: '道路检测置信度',
        trashDetectThreshold: '垃圾检测置信度',
        kitchenBehaviorDetectThreshold: '厨房检测置信度',
        layer: '算法图层',
        currentTime: '{num}前',
        road: '道路任务',
        waste: '垃圾检测',
        kitchen: '原料盒检测',
        touchFaceConfidence: '摸口鼻',
        eatFoodConfidence: '吃食物',
        animalsInsects: '厨房害虫检测',
        mouseDetectConfidence: '老鼠',
        catDetectConfidence: '猫',
        dogDetectConfidence: '狗',
        tableDetection: '桌面检测',
        foodResidueConfidence: '桌面食物残留',
        lidUncoverDetectConfidence: '盒盖打开',
        fireDetection: '烟火检测',
        abnormalBehavior: '异常行为检测',
        fallDownConfidence: '跌倒',
        fightingConfidence: '打架',
        traffic: '交通事件',
        trafficReverseConfidence: '逆行',
        counterflowDriving: '逆行',
        trafficIllegalStopConfidence: '违停',
        trashBinUncoverConfidence: '垃圾盖打开',
        abnormalBehaviorDetectThreshold: '异常行为检测置信度',
        foldAllConfidence: '折叠置信度',
        showAllConfidence: '展示置信度',
        fireDetectionConfidence: '烟火检测置信度',
        fire: '烟火',
        pestDetectThreshold: '厨房害虫检测置信度',
        tableDetectThreshold: '桌面检测置信度',
        kitchenWareThreshold: '原料盒检测置信度',
        trafficReverseThreshold: '交通事件检测置信度',
        trafficIllegalStopThreshold: '交通事件检测置信度',
        confirm: '确定',
        mainImage: '目标对象',
        libaryImage: '人像库图片',
        unidentifiedObjectRetention: '不明物体滞留检测',
        unidentified: '物品检测',
        nonMotorVehicle: '非机动车',
    },
};
